import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-contact-us',
    templateUrl: './contact-us.component.html',
})
export class ContactUsComponent implements OnInit {
    // Emails
    emails = environment.settings.societyDetails.emails;

    constructor() {}

    ngOnInit() {}
}
